/**
 * @module Annual Report - Map
 * @description JS for Annual Report Template - Map
 */

const els = {
  map: null,
  tooltip: null,
  hoverEl: null,
  toolTipData: {}
};


/**
 * @function init
 * @description Kick off this modules functions
 */
const init = ( map ) => {
  els.map = map;

  bindToolTip();
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
//
// Tooltip Setup
//
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

const toolTipHtml = `
  <div
    class="tooltip__box --pos-center"
    role="tooltip"
    data-tooltip="content"
    aria-hidden="true"
    style="display: none"
    >
    <div class="tooltip__arrow"></div>
    <ul class="list-bare">
      <li class="+type-heading-six +text-center +mg-bottom-sm tooltip__location-label">
        The face value of a loan, independent of the interest charged on the loan amount.
      </li>
      <li class="+type-body-two +fg-slate +text-center tooltip__location-rank">
        Payments made to a lender by a borrower in exchange for a loan.
      </li>
    </ul>
  </div>`;

const bindToolTip = () => {
  els.map.style.position = 'relative';

  // Use this if we want to position the tooltip in the center of the state
  // const mapRect = els.map.getBoundingClientRect();

  const toolTipEl = document.createElement('div');
  toolTipEl.innerHTML = toolTipHtml;
  toolTipEl.style.position = 'absolute';

  els.map.appendChild(toolTipEl);

  els.map.addEventListener('mousemove', (e) => {
    e.preventDefault();

    const polygonPath = els.map.getAttribute('data-view') === 'metro' ? e.path[0] : e.path[1];
    els.tooltip = els.map.querySelector('.tooltip__box');
    const toolTipLabel = els.tooltip.querySelector('.tooltip__location-label');
    const toolTipRank = els.tooltip.querySelector('.tooltip__location-rank');


    if (polygonPath.classList && polygonPath.classList.contains('location')) {
      // Use this if we want to position the tooltip in the center of the state
      // const { x, y, width, height, top, bottom, left, right } = polygonPath.getBoundingClientRect();
      // const yCoord = top - mapRect.top + (height / 2);
      // const xCoord = left - mapRect.left + (width / 2);

      // Use this if we want the box to move with the mouse
      const yCoord = e.offsetY;
      const xCoord = e.offsetX;
      
      toolTipEl.style.top = yCoord + 'px';
      toolTipEl.style.left = xCoord + 'px';

      if (els.toolTipData.location && els.toolTipData.rank) {
        els.tooltip.style.display = 'block';
      } else {
        els.tooltip.style.display = 'none';
      }

      // Displaying Data in tooltip
      toolTipLabel.innerText = els.toolTipData?.location
      if (polygonPath.classList.contains('location--state')) {
        toolTipRank.innerText = `#${els.toolTipData?.rank} of 50`
      }

      if (polygonPath.classList.contains('location--metro')) {
        toolTipRank.innerText = `#${els.toolTipData?.rank} of 25`
      }

      // Updating data for tooltip
      if (els.hoverEl === null || polygonPath !== els.hoverEl) {
        els.hoverEl = polygonPath
        els.toolTipData = JSON.parse(polygonPath.getAttribute('data-location-data'))
      }
    } else {
      els.tooltip.style.display = 'none';
      els.hoverEl = null;
      els.toolTipData = {};
    }
  })
}

export default init
